import React, {
    memo, useCallback, useEffect, useRef, useState
} from 'react';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import removeParamsFormHash from '@utils/removeParamasFromHash';
import { setFilter } from '../store/actions';
import styles from '../../../styles/components/searchInput.module.scss';
import { IconSearch } from './icons';

const SearchSelect = memo(({
    title, content, parentValue, selected, placeholder,
}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const filterCard = useRef(null);
    const [data, setData] = useState([]);

    // selectorStyles object
    const customStyles = {
        option: (styles, state) => ({
            ...styles,
            cursor: 'pointer',
            textTransform: 'capitalize',
            minHeight: '2.625rem',
            height: 'fit-content',
        }),
        control: (styles) => ({
            ...styles,
            cursor: 'pointer',
            minHeight: '2.625rem',
            height: 'fit-content',
            borderRadius: '0',
        }),
    };

    useEffect(() => {
        setData(selected);
    }, [selected]);

    const handleClick = useCallback(async (value, action) => {
        const activeItems = {};

        [...data, ...value].forEach((item) => {
            if (activeItems[item.value]) {
                activeItems[item.value] = { count: activeItems[item.value]?.count + 1, value: item.value };
            } else {
                activeItems[item.value] = { count: 1, value: item.value };
            }
        });

        const activeItem = Object.values(activeItems) ? Object.values(activeItems).find((el) => el.count < 2) : {};

        if (action.action === 'remove-value') {
            dispatch(setFilter(removeParamsFormHash(history.location.hash.replace('#', ''), activeItem.value), true));
        }

        if (action.action === 'select-option') {
            dispatch(setFilter(`${parentValue}=${activeItem.value}`));
        }
    }, [data]);

    return (
        <div className={styles.searchFacet}>
            <div className={styles.label}>
                {title}
            </div>
            <Select
                ref={filterCard}
                styles={customStyles}
                classNamePrefix={"searchSelect-select"}
                className={styles.input}
                isMulti
                options={content.map(({ label, value }) => ({ value, label }))}
                isClearable={false}
                placeholder={`${placeholder}`}
                value={selected}
                onChange={(value, action) => handleClick(value, action)}
                />
        </div>
    );
});

export default SearchSelect;
